import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useEffect } from 'react'
import * as bie from "react-bootstrap";
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import Swal from 'sweetalert2';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice';
export default function Afflsectioncaluclation() {
    const Collegetype = useSelector((state) => state?.commonMastersReducer?.CollegeType);
    const AfflSectionValidation = Yup.object({
        registeredLeaseTotalArea: Yup.string().required(ERROR_MSG).nullable(),
        totalArea: Yup.string().required(ERROR_MSG).nullable(),
        totalAreaToRunCourses: Yup.string().required(ERROR_MSG).nullable(),
    })
    const AfflSectionCalFormik = useFormik({
        initialValues: {
            registeredLeaseTotalArea: "",
            totalArea: "",
            totalAreaToRunCourses: "",
            deficiencyArea: ""
        },
        validationSchema: AfflSectionValidation,
        onSubmit: (values) => {
            const updatedValues = {
                ...values,
                registeredLeaseTotalArea: values?.registeredLeaseTotalArea,
                totalArea: values?.totalArea,
                totalAreaToRunCourses: values?.totalAreaToRunCourses,
            };
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}savePlinthAreaDetails`;
                    CommonAxiosPost(url, updatedValues).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetPlinthAreaDetails();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })

    const handleAreaCalculation = (e, totalAreaName, totalAreaToRunCoursesName, deficiencyAreaName) => {
        const totalAreaValue = parseFloat(e.target.form[totalAreaName].value) || 0;
        const totalAreaToRunCoursesValue = parseFloat(e.target.form[totalAreaToRunCoursesName].value) || 0;
        const deficiencyAreaValue = totalAreaValue - totalAreaToRunCoursesValue;
        AfflSectionCalFormik.setFieldValue(deficiencyAreaName, deficiencyAreaValue);
    };

    const handleAreaCheck = (e) => {
        const totalArea = parseInt(e.target.form.registeredLeaseTotalArea.value, 10) || 0;
        const totalAreaToRunCourses = parseInt(e.target.value, 10) || 0;

        if (totalAreaToRunCourses > totalArea) {
            Swal.fire({
                icon: 'warning',
                text: '(b) Total Area available as per FFCA cannot be greater than (a) Total Area Available as Per Approved Building Plan.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#d33',
                backdrop: false,
            });

            e.target.value = '';  // Clear the (b) field
            AfflSectionCalFormik.setFieldValue("totalArea", '');
            AfflSectionCalFormik.setFieldValue("deficiencyArea", '');

        }
    };

    function GetPlinthAreaDetails() {
        let url = config.url.API_URL + `getPlinthareaData`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                AfflSectionCalFormik?.setFieldValue(`registeredLeaseTotalArea`, res?.data?.getPlinthareaData[0]?.resgistered_lease_total_area);
                AfflSectionCalFormik?.setFieldValue(`totalArea`, res?.data?.getPlinthareaData[0]?.total_area);
                AfflSectionCalFormik?.setFieldValue(`totalAreaToRunCourses`, res?.data?.getPlinthareaData[0]?.total_area_to_run_courses);
                AfflSectionCalFormik?.setFieldValue(`deficiencyArea`, res?.data?.getPlinthareaData[0]?.deficiency_area);


            } else {

            }
        })
    }

    useEffect(() => {
        GetPlinthAreaDetails();
        GetCollegeType()
    }, [])


    return (
        <>
            <CommonFormHeading heading="Plinth Area Calculation" />

            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">

                    <FormikProvider value={AfflSectionCalFormik}>
                        <Form onChange={AfflSectionCalFormik.handleChange} onSubmit={AfflSectionCalFormik.handleSubmit} className='affl-form'>
                            <bie.Row className="px-2 pt-3 mb-3">

                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Total Area Available as Per Approved Building Plan ({Collegetype})</label>
                                        <Field type='text' name="registeredLeaseTotalArea" className='form-control mb-2 mt-3' onPaste={(e) => handlePaste(e)}
                                            onKeyPress={(e) => { AllowFloats(e); }} />

                                        <ErrorMessage name="registeredLeaseTotalArea" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory' >Total Area available as per FFCA ({Collegetype})</label>
                                        <Field type='text' name="totalArea" className='form-control mb-2 mt-3' onPaste={(e) => handlePaste(e)}
                                            onKeyPress={(e) => { AllowFloats(e); }}
                                            onKeyUp={(e) => { handleAreaCalculation(e, "totalArea", "totalAreaToRunCourses", "deficiencyArea"); handleAreaCheck(e) }} />
                                        <ErrorMessage name="totalArea" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Total Area required to run the Courses ({Collegetype})</label>
                                        <Field type='text' name="totalAreaToRunCourses" className='form-control mb-2 mt-3 mt-xl-0 mt-lg-0 mt-xxl-3' onPaste={(e) => handlePaste(e)}
                                            onKeyPress={(e) => { AllowFloats(e); }}
                                            onKeyUp={(e) => handleAreaCalculation(e, "totalArea", "totalAreaToRunCourses", "deficiencyArea")} />

                                        <ErrorMessage name="totalAreaToRunCourses" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Deficiency (b-c)</label>
                                        <Field type='text' name="deficiencyArea" className='form-control mb-2 mt-3' disabled />
                                    </bie.Col>
                                </bie.Row>
                                <div className="button-cend pt-1 mb-3">
                                    <button type='submit' className='btn btn-success btn-sm float-end mb-2'>Submit</button>
                                </div>
                            </bie.Row>
                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>

        </>
    )
}
